import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiExtendedDeviation } from '@wix/da-papi-types';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import s from './JournalTags.scss';

export interface Props {
  tags: PapiExtendedDeviation['tags'];
}

export const JournalTags: React.FC<Props> = ({ tags }) => {
  const { t } = useTranslation();
  return tags ? (
    <div className={s['tags']}>
      <FoldableTagList
        tags={tags}
        moreLabel={
          <span title={t('common.showMore')} aria-label={t('common.showMore')}>
            {t('common.moreEllipsis')}
          </span>
        }
      />
    </div>
  ) : null;
};
JournalTags.displayName = 'JournalTags';

export default JournalTags;
